<template>
    <Path>
        <template v-slot:path>
            <li><router-link :to="{name: 'dashboard'}" >الصفحة الرئيسية</router-link> </li>
            <li> <span class="divider"> / </span><a href="#">الأخبار </a> </li>
        </template>
    </Path>

    <section>
        <div class="py-4 ">
            <div class="container">
                <div class="row">
                    <div class="col-12 mb-2 ">

                        <h1 class="blueFont py-3"> تخصيص (مكتب لذوى الهمم - كبار السن- المرضى) بديوان القطاع والمنافذ
                            الجغرافية </h1>

                        <p>
                            تنفيذا لتوجيهات السيد الفاضل اللواء وزير الداخليه وموافقه سيادته على تنفيذ خطه تطوير اداء
                            القطاع والارتقاء بالخدمات المقدمه لجمهور المواطنين والتيسير عليهم لمواجهه التحديات والمعوقات
                            التى تؤثر على منظومه العمل بقطاع الاحوال المدنية وبناء على توجيهات السيد اللواء مساعد الوزير
                            لقطاع الاحوال المدنية تم تنفيذ الاتى :
                            <br>
                            تخصيص (مكتب لذوى الهمم - كبار السن- المرضى) بديوان القطاع والمنافذ الجغرافية مُزوده بكافة
                            اللوجيستيات المُعاونه بما يُمكن حصولهم كافة الخدمات بأوجه التيسيرات الممكنه تماشياً ومبادئ
                            حقوق الإنسان وتشغيل (3) شاشات تلامسية لذوى الإعاقة السمعية واللغوية لتمكنهم من تلقى خدمات
                            القطاع وإستخراج كافة المًصدرات الثبوتية لذوى الهمم فى كافة الإحتفالات والأعياد والمُبادرات
                            الخاصة بهم (بالمجان) .
                        </p>


                        <img src="@/assets/images/smartrecord.jpg" alt="" class="img-fluid py-3">
                    </div>

                </div>
            </div>
        </div>
    </section>



</template>

<script>
import Path from '@/components/Path.vue'
export default {
    name: 'News7Comp',
    components: { Path },
    created() {
        window.scrollTo({ top: 0, behavior: "smooth" });
    },
}
</script>